/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Tlm_0Inputs */

const en_svc_ai_integration_tlm_0 = /** @type {(inputs: Svc_Ai_Integration_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`surface`)
};

const ar_svc_ai_integration_tlm_0 = /** @type {(inputs: Svc_Ai_Integration_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السطح`)
};

const bn_svc_ai_integration_tlm_0 = /** @type {(inputs: Svc_Ai_Integration_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`surface`)
};

const de_svc_ai_integration_tlm_0 = /** @type {(inputs: Svc_Ai_Integration_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberfläche`)
};

const es_svc_ai_integration_tlm_0 = /** @type {(inputs: Svc_Ai_Integration_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`superficie`)
};

const fr_svc_ai_integration_tlm_0 = /** @type {(inputs: Svc_Ai_Integration_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surface`)
};

const pt_svc_ai_integration_tlm_0 = /** @type {(inputs: Svc_Ai_Integration_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superfície`)
};

const zh_svc_ai_integration_tlm_0 = /** @type {(inputs: Svc_Ai_Integration_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表面`)
};

const tr_svc_ai_integration_tlm_0 = /** @type {(inputs: Svc_Ai_Integration_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yüzey`)
};

const ru_svc_ai_integration_tlm_0 = /** @type {(inputs: Svc_Ai_Integration_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`поверхность`)
};

const pl_svc_ai_integration_tlm_0 = /** @type {(inputs: Svc_Ai_Integration_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`powierzchnia`)
};

/**
* | output |
* | --- |
* | "surface" |
*
* @param {Svc_Ai_Integration_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_tlm_0 = /** @type {((inputs?: Svc_Ai_Integration_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_tlm_0(inputs)
	if (locale === "bn") return bn_svc_ai_integration_tlm_0(inputs)
	if (locale === "de") return de_svc_ai_integration_tlm_0(inputs)
	if (locale === "es") return es_svc_ai_integration_tlm_0(inputs)
	if (locale === "fr") return fr_svc_ai_integration_tlm_0(inputs)
	if (locale === "pt") return pt_svc_ai_integration_tlm_0(inputs)
	if (locale === "zh") return zh_svc_ai_integration_tlm_0(inputs)
	if (locale === "tr") return tr_svc_ai_integration_tlm_0(inputs)
	if (locale === "ru") return ru_svc_ai_integration_tlm_0(inputs)
	if (locale === "pl") return pl_svc_ai_integration_tlm_0(inputs)
	return en_svc_ai_integration_tlm_0(inputs)
});
export { svc_ai_integration_tlm_0 as "svc_ai-integration_tlm_0" }